import * as THREE from 'three'
import Experience from '../Experience.js'
import * as CANNON from 'cannon-es'

export default class Shelf {
    parameters = {
        width: 4,
        height: 3,
        depth: 1 - 0.1,
        mass: 400,
        successColor: '#2D8D39',
        identifier: 'X',
        target: false
    }

    constructor(identifier, width, target) {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.resources
        this.physics = this.experience.physics

        this.parameters.identifier = identifier
        this.parameters.width = width - 0.1
        this.parameters.target = target

        this.setModel()
        this.setPhysics()
    }

    setPosition(x, y, z) {
        // Set position of mesh
        this.model.position.set(x + this.parameters.width / 2, y, z)
        // Set position of physics body
        this.body.position.set(x + this.parameters.width / 2, y, z)
    }

    setRotation(angle) {
        // Set rotation of mesh
        this.model.position.x -= this.parameters.width / 2 - 0.5
        this.model.position.z += this.parameters.depth + 0.5
        this.model.rotation.y = angle * Math.PI / 180
        // Set rotation of physics body
        this.body.position.x -= this.parameters.width / 2 - 0.5
        this.body.position.z += this.parameters.depth + 0.5
        this.body.quaternion.setFromAxisAngle(new CANNON.Vec3(0, 1, 0), angle * Math.PI / 180)
    }

    setModel() {
        if (this.parameters.target) {
            this.model = this.resources.items.shelfTargetModel.clone()
            // Update color
            this.model.children[0].children[0].material.color = new THREE.Color(this.parameters.successColor)
        } else {
            this.model = this.resources.items.shelfModel.clone()
        }

        // Get model outer dimensions
        let bbox = new THREE.Box3().setFromObject(this.model);
        let sizes = bbox.getSize(new THREE.Vector3());

        // Change model scale according to parameters
        this.model.scale.set((this.parameters.width / sizes.x), (this.parameters.height / sizes.y), (this.parameters.depth / sizes.z))

        // bbox = new THREE.Box3().setFromObject(this.model);
        // sizes = bbox.getSize(new THREE.Vector3());
        // let helper = new THREE.Box3Helper(bbox, new THREE.Color(0, 255, 0));
        // this.scene.add(helper);

        this.scene.add(this.model)

    }

    setPhysics() {
        const width = this.parameters.width
        const height = this.parameters.height
        const depth = this.parameters.depth
        const mass = this.parameters.mass
        this.body = new CANNON.Body({
            mass: mass,
        })

        // Construct detailed shape
        const shelf_offset = height / 2
        const shelf_shape = new CANNON.Box(new CANNON.Vec3(width / 2, 0.04, depth / 2))
        const pole_shape = new CANNON.Box(new CANNON.Vec3(0.11, height / 2 - 0.01, 0.06))


        // Add shelves
        this.body.addShape(shelf_shape, new CANNON.Vec3(0, 0.2 - shelf_offset, 0))
        this.body.addShape(shelf_shape, new CANNON.Vec3(0, height / 3 + 0.05 - shelf_offset, 0))
        this.body.addShape(shelf_shape, new CANNON.Vec3(0, height * 2 / 3 - 0.1 - shelf_offset, 0))
        this.body.addShape(shelf_shape, new CANNON.Vec3(0, height - 0.25 - shelf_offset, 0))

        // Add poles
        this.body.addShape(pole_shape, new CANNON.Vec3(width / 2 - 0.14, height / 2 - shelf_offset + 0.02, depth / 2 - 0.08))
        this.body.addShape(pole_shape, new CANNON.Vec3(width / 2 - 0.14, height / 2 - shelf_offset + 0.02, - depth / 2 + 0.08))
        this.body.addShape(pole_shape, new CANNON.Vec3(-width / 2 + 0.14, height / 2 - shelf_offset + 0.02, depth / 2 - 0.08))
        this.body.addShape(pole_shape, new CANNON.Vec3(-width / 2 + 0.14, height / 2 - shelf_offset + 0.02, - depth / 2 + 0.08))


        this.physics.world.addBody(this.body)
        this.physics.objectsToUpdate.push({
            mesh: this.model,
            body: this.body
        })
    }

    update() {
        // Animate on y position if target is true
        if (this.parameters.target) {
            this.model.position.y = 1 + Math.abs(Math.sin(this.experience.time.elapsed * 0.005) * 2)
        }
    }
}